import { render } from "./RegistroCuentaAlumno.vue?vue&type=template&id=8e65e3fe&scoped=true"
import script from "./RegistroCuentaAlumno.vue?vue&type=script&lang=js"
export * from "./RegistroCuentaAlumno.vue?vue&type=script&lang=js"

import "./RegistroCuentaAlumno.vue?vue&type=style&index=0&id=8e65e3fe&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e65e3fe"]])

export default __exports__